import React from "react";
import {
  BonusModal,
  PromoFirstTimeBonusBgCh,
  PromoFirstTimeBonusBgMM,
  PromoFirstTimeBonusBgEng,
} from "@assets";
import Lottie from "react-lottie";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import {
  Modal,
  LottieWrapper,
  Container,
  CancelButton,
  BtnWrapper,
  RuleLabel, Bottom,
  TotalLabel,
  TopStarIcon,
  FirstLabel,
  LabelContainer,
  Title,
  TopUpLabel,
  AcceptButton,
  BottomStarIcon,
} from './FirstBonusConfirmModal.style'
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { localStorage } from "@utils";

const FirstBonusConfirmModal = ({
  amount,
  bonus_percent,
  open,
  onBonusAccept,
  handleClose,
  isPromoUser,
  exceed_bonus_limit,
  total_amount,
  max_topup_reward,
}) => {
  const { t } = useTranslation();

  const calculateBonus = () => {
    return exceed_bonus_limit ? max_topup_reward : Math.ceil(amount * bonus_percent * 0.01);
  }

  const calculateTotal = () => {
    return exceed_bonus_limit ? total_amount : (amount + calculateBonus());
  }

  const getBgToShow = () => {
    const userPreferedLanguage = localStorage.getUserPreferedLanguage();

    if (isPromoUser) {
      if (userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK) {
        return PromoFirstTimeBonusBgEng;
      } else if (userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK) {
        return PromoFirstTimeBonusBgMM;
      } else {
        return PromoFirstTimeBonusBgCh;
      }
    } else {
      return BonusModal;
    }
  }

  return (
    <>
      <Modal
        centered
        destroyOnClose
        closable={false}
        open={open}
        footer={null}
      >
        <LottieWrapper>
          <Lottie
            options={{
              animationData: getBgToShow(),
            }}
          />
          <Container>
            {!isPromoUser && <Title>{t("wallet.firstTopUpBonusTitle")}</Title>}

            <LabelContainer isPromoUser={isPromoUser ? "true" : 'false'}>
              <FirstLabel>
                {t("wallet.firstTopUpBonusPercentage1")}
                {" - "}
                <span>{bonus_percent}%</span>
                {" "}
                {t("wallet.firstTopUpBonusPercentage2")}
              </FirstLabel>
              <TopUpLabel>
                {t("wallet.firstTopUpBonusTopUpAndBonus1")}
                {" - "}
                <span>{getFormattedNumber(amount)}</span>
                {"၊ "}
                {t("wallet.firstTopUpBonusTopUpAndBonus2")}
                {" - "}
                <span>{getFormattedNumber(calculateBonus())}</span>
              </TopUpLabel>
              <TotalLabel>
                {t("wallet.firstTopUpBonusTotal1")}
                {" "}
                <span>{getFormattedNumber(calculateTotal())}</span>
                {" "}
                {t("wallet.firstTopUpBonusTotal2")}
              </TotalLabel>
              {exceed_bonus_limit &&
                <TotalLabel>
                  {t("wallet.maxBonusAmount", { max_topup_reward: getFormattedNumber(max_topup_reward) })}
                </TotalLabel>
              }
            </LabelContainer>
            <Bottom>
              <RuleLabel>{t("wallet.firstTopUpBonusRule")}</RuleLabel>
              <BtnWrapper>
                <CancelButton onClick={handleClose}>
                  {t("wallet.reject")}
                </CancelButton>
                <AcceptButton onClick={onBonusAccept}>
                  <TopStarIcon />
                  <BottomStarIcon />
                  {t("wallet.accept")}
                </AcceptButton>
              </BtnWrapper>
            </Bottom>
          </Container>
        </LottieWrapper>
      </Modal>
    </>
  );
};

export default FirstBonusConfirmModal;
